import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {BenutzerDTO} from "../../../models/benutzer/BenutzerDTO";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {CustomToastService} from "../../utils/custom-toast.service";
import {BenutzerService} from "../../services/benutzer/benutzer.service";
import {catchError} from "rxjs/operators";
import {EMPTY} from "rxjs";

@Component({
    selector: 'app-aktivierung',
    templateUrl: './aktivierung.component.html',
    styleUrls: ['./aktivierung.component.scss'],
    standalone: false
})
export class AktivierungComponent implements OnInit {

  public dto: BenutzerDTO;

  token: string;
  infoText: string = "";

  constructor(private route: ActivatedRoute,
              private router: Router,
              public translate: TranslateService,
              private customToastService: CustomToastService,
              private benutzerService: BenutzerService,
              private fb: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.token = params.token;
        this.activate();
      });
  }

  activate(){
    this.benutzerService.activateBenutzer({
      kennwort: null,
      token : this.token
    })
        .pipe(
          catchError(() => {
            this.customToastService.showError(this.translate.instant('AUTHENTICATION.ACTIVATION.FAILED'));
            this.infoText = this.translate.instant('AUTHENTICATION.ACTIVATION.FAILED');
            return EMPTY;
          }))
        .subscribe((data: BenutzerDTO) => {
          this.dto = {...data};
          this.router.navigate(['/authentication/login']);
          this.customToastService.showSuccess(this.translate.instant('AUTHENTICATION.ACTIVATION.SUCCESS'));
          this.infoText = this.translate.instant('AUTHENTICATION.ACTIVATION.SUCCESS');
        });
  }

}
